export default __webpack_public_path__ + "static/media/arrow3.6e1c5aa4.svg";